/**
 * Formats a number into Indian currency abbreviations (Cr, Lacs, K).
 * @param {number} amount - The amount to format.
 * @returns {string} - The formatted string.
 */
export const formatIndianNumber = (amount) => {
  if (amount === null || amount === undefined) return "N/A";
  if (typeof amount === "string" && isNaN(Number(amount))) return amount;
  if (typeof amount === "number" && isNaN(amount)) return "N/A";

  const absAmount = Math.abs(amount);
  let formatted = "";

  if (absAmount >= 10000000) {
    formatted = (amount / 10000000).toFixed(2) + " Cr";
  } else if (absAmount >= 100000) {
    formatted = (amount / 100000).toFixed(2) + " Lacs";
  } else if (absAmount >= 1000) {
    formatted = (amount / 1000).toFixed(2) + " K";
  } else {
    formatted = amount.toFixed(2);
  }

  return formatted;
};

/**
 * Standard Indian Currency Formatter (Full).
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return "N/A";
  if (typeof amount === "string" && isNaN(Number(amount))) return amount;
  if (typeof amount === "number" && isNaN(amount)) return "N/A";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2
  }).format(amount);
};
